import { createI18n } from 'vue-i18n';
const requireContext = require.context('./locales', true, /\.json$/);

function loadLocaleMessages() {
  const messages = {};
  requireContext.keys().forEach((fileName) => {
    const locale = fileName.split('/').pop().replace('.json', '');
    messages[locale] = requireContext(fileName);
  });

  return messages;
}

// Create a Vue i18n instance
const i18n = createI18n({
  legacy: false, 
  locale: process.env.VUE_APP_I18N_LOCALE || 'en', 
  fallbackLocale: process.env.VUE_APP_I18N_LOCALE || 'en', 
  globalInjection: true,
  messages: loadLocaleMessages(), 
});

export default i18n;
